import { defineStore } from 'pinia'
import { reactive } from 'vue'
import { ECMSType, ECMSPage, EPageSectionType } from '@/modules/adminModule/constants/pagesCMSconstants'

interface IStorePromises {
	fetchPageSectionsPromise: Promise<IHomePageSectionModel[]> | null
}

export interface IPageSectionsStoreState {
	pageSections: IHomePageSectionModel[] | null
}

export interface IPageSectionsStore {
	readonly state: {
		pageSections: IHomePageSectionModel[] | null
	}
	fetchPageSections: () => Promise<IHomePageSectionModel[] | undefined>
	getPageSections: ComputedRef<IHomePageSectionModel[] | null>
	pageMetaObject: ComputedRef<IHomePageSectionModel | undefined>
}

export const usePageSectionsStore = defineStore('pageSectionsStore', (): IPageSectionsStore => {
	const { getLocaleLang } = usei18nService()

	const _state = reactive<IPageSectionsStoreState>({
		pageSections: null,
	})

	const promises: IStorePromises = {
		fetchPageSectionsPromise: null,
	}

	const fetchPageSections = async () => {
		try {
			if (_state.pageSections) {
				return _state.pageSections
			}

			if (promises.fetchPageSectionsPromise) {
				return promises.fetchPageSectionsPromise
			}

			promises.fetchPageSectionsPromise = (async () => {
				const fetchedPageSections = await ApiService.fetchPageSections(ECMSType.SUBPAGE, ECMSPage.HOME, getLocaleLang())
				// pageSections.value = response.data
				// pageMetaObject.value = response.data
				// 	?.find((section) => section.name === EPageSectionType.META)
				// 	?.translations.find((translation) => translation.language === locale.value)?.content[0]

				if (fetchedPageSections) {
					_state.pageSections = fetchedPageSections.data
				} else {
					_state.pageSections = null
				}

				return _state.pageSections as IHomePageSectionModel[]
			})()

			return await promises.fetchPageSectionsPromise
		} catch (error) {
			console.log(error)
		}
	}

	const getPageSections = computed(() => _state.pageSections)

	const pageMetaObject = computed(() => {
		return _state.pageSections
			?.find((section) => section.name === EPageSectionType.META)
			?.translations.find((translation) => translation.language === 'pl')?.content[0]
	})

	return {
		state: _state,
		fetchPageSections,
		getPageSections,
		pageMetaObject,
	}
})
